// extracted by mini-css-extract-plugin
module.exports = {"battery_indicator":"Battery_battery_indicator__3qoWr","battery_tooltip":"Battery_battery_tooltip__1oJ1L","battery_zoom_tooltip_extend":"Battery_battery_zoom_tooltip_extend__FxAK3"};